export const ccrpDataSources = [
  {
    title: 'CCRP',
    content:
      'The latest version of the chatbot has been trained using data from Hitachi Energy’s Customer Care Response Process (CCRP) application. This upgraded CCRP agent, known as Akira CCRP, supports users in analyzing and tracking CCRP-related data more effectively. In addition to clarifying CCRP-specific terminology, Akira now delivers insights into key performance indicators (KPIs) and the voice of the customer. It can generate tailored visualizations based on fiscal years, business units, product groups, or hubs. Furthermore, Akira can connect to historical data, offering valuable insights into past actions and trends. These capabilities empower users to monitor metrics such as (ROT) resolved on time, CCRP volume, and high-impact CCRPs—ultimately driving continuous process improvement through data-driven decision-making.',
    sourceSystem: null,
    prompts: [
      'Can you provide Resolved on Time for all Business Units of Hitachi Energy?',
      'How many CCRPs were submitted last month in Transformer business?',
      'How many high-impact CCRPs are there for FY24 in High Voltage Business?',
      'Oil leakage issue in Transformer Business - can you share some past CCRP numbers with this failure mode?'
    ],
    datasourcelink: ''
  }
]
